import React from 'react'
import { FaUsers } from "react-icons/fa6";
import { GrProjects } from "react-icons/gr";
import { IoLocation } from "react-icons/io5";
import { FaHandshake, FaBuilding } from "react-icons/fa";


const Numbers = () => {
    const data = [
        {
            id: 0,
            icon: <IoLocation size={25} />,
            number: "20+",
            title: "Locations Offer"
        },
        {
            id: 1,
            icon: <FaUsers size={25} />,
            number: "25+",
            title: "Leading Developers"
        },
        {
            id: 2,
            icon: <FaBuilding size={22} />,
            number: "50+",
            title: "Best Projects"
        },
        {
            id: 3,
            icon: <GrProjects size={25} />,
            number: "70+",
            title: "Options Available"
        },
        {
            id: 4,
            icon: <FaHandshake size={23} />,
            number: "100+",
            title: "Hot & Big Deals"
        }
    ]

    return (
        <section className="px-4 sm:px-6 lg:px-8 py-12 bg-gray-50">
            <div className="bg-white rounded-xl p-6 sm:p-10 lg:p-16">
                <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-xl sm:text-2xl md:text-3xl uppercase font-bold text-gray-800 mb-10">
                        Why Choose <span className="text-green-600">Investycoons?</span>
                    </h2>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-left">
                        {[
                            "Pan-India Property Listings",
                            "RERA-Verified & Legally Clear Projects",
                            "High-ROI Investment Options",
                            "Zero Brokerage on Select Deals",
                            "Dedicated Relationship Managers",
                            "Trusted by 500+ Happy Clients",
                        ].map((point, index) => (
                            <div
                                key={index}
                                className="flex items-start bg-gray-50 rounded-lg shadow-sm p-5 border-2  hover:shadow-md hover:border-green-600 transition"
                            >
                                <div className="flex-shrink-0">
                                    <div className="w-8 h-8 bg-green-100 text-green-600 flex items-center justify-center rounded-full">
                                        <svg
                                            className="w-5 h-5"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                </div>
                                <p className="ml-4 text-gray-700 font-medium text-justify">{point}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Stats Section */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mt-12">
                {data.map((item, index) => (
                    <div
                        key={index}
                        className="flex items-center p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:border-green-500 transition"
                    >
                        <div className="p-3 mr-4 bg-green-500 text-white rounded-full">
                            {item.icon}
                        </div>
                        <div>
                            <p className="mb-1 text-2xl font-bold text-green-500">
                                {item.number}
                            </p>
                            <p className="text-sm font-medium text-gray-600">{item.title}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>

    )
}

export default Numbers